export enum TestId {
    ACTOR_NAME = 'actorName',
    ASSIGNMENT = 'assignment',
    ATTACH_BUTTON = 'attachButton',
    BOOKING_CARD = 'bookingCard',
    BOOKING_STATUS = 'bookingStatus',
    BOT_BUBBLE = 'botBubble',
    BOTTOMSHEET_HEADER = 'bottomsheetHeader',
    CHECKBOX = 'checkbox',
    CHECKBOX_LIST = 'checkboxList',
    CHECKBOX_WRAPPER = 'checkboxWrapper',
    CLOSE_BUTTON = 'closeButton',
    CONTACT_SUPPORT_SHEET = 'contactSupportSheet',
    TIMELINE_ENTRY_DETAILS = 'timelineEntryDetails',
    DOT = 'dot',
    DROPOFF_LOCATION = 'dropoffLocation',
    META_INFO = 'metaInfo',
    ORIGIN_AND_DESTINATION = 'originAndDestination',
    PICKUP_LOCATION = 'pickupLocation',
    PRODUCT_TITLE = 'productTitle',
    QUERY_RESOLUTION = 'queryResolution',
    RADIO = 'radio',
    RADIO_LIST = 'radioList',
    RADIO_WRAPPER = 'radioWrapper',
    REFUND_BREAKUP = 'refundBreakup',
    REFUND_NET_AMOUNT = 'refundNetAmount',
    REFUND_SUMMARY = 'refundSummary',
    REFUND_DISCLAIMER = 'refundDisclaimer',
    RESOLUTION = 'resolution',
    SELECTED_PAX = 'selectedPax',
    SELECTED_REASON = 'selectedReason',
    SEND_BUTTON = 'sendButton',
    SEPARATOR = 'separator',
    SPINNER_LOADER = 'spinnerLoader',
    SUGGESTION = 'suggestion',
    THUMBNAIL = 'thumbnail',
    TIMELINE = 'timeline',
    TIMELINE_STEP = 'timelineStep',
    TIMELINE_SOURCE = 'timelineSource',
    TIMESTAMP = 'timestamp',
    TRAVEL_DATE = 'travelDate',
    TYPING_LOADER = 'typingLoader',
    UPLOADER = 'uploader',
    USER_BUBBLE = 'userBubble',
}
